import type { AnchorHTMLAttributes } from 'react'
import { useTheme } from 'styled-components'

import { Link } from '../../Link/Link'
import { Typography } from '../../Typography'

import { StyledContainer, StyledLinkContainer } from './Footer.Styled'

type LinkProps = Pick<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  'href' | 'rel' | 'target'
> & { text: string }

export type FooterProps = {
  links: LinkProps[]
}

export const Footer = ({ links }: FooterProps) => {
  const theme = useTheme()
  return (
    <StyledContainer>
      <Typography
        $color={theme.colors['N Content/Tertiary']}
        $variant="Poppins/T3"
      >
        &copy; Fitify Workouts s.r.o., {new Date().getFullYear()}
      </Typography>
      <StyledLinkContainer>
        {links.map(({ text, ...htmlProps }) => (
          <Link key={text} {...htmlProps} $variant="Poppins/T3">
            {text}
          </Link>
        ))}
      </StyledLinkContainer>
    </StyledContainer>
  )
}
